
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { Loader2 } from "lucide-react";

export const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [showingLoader, setShowingLoader] = useState(false);

  // Effect to handle authentication loading state
  useEffect(() => {
    // Only show loader if we're loading AND have a user session
    // This prevents showing loader for unauthenticated users
    if (loading && user) {
      setShowingLoader(true);
    } else {
      setShowingLoader(false);
    }
  }, [loading, user]);

  // If we know user is not authenticated, immediately redirect to login
  if (!loading && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Show loading state only if we're checking auth status for a logged-in user
  // or still loading the initial auth state
  if (loading || showingLoader) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Loader2 className="h-8 w-8 animate-spin text-gray-600 mr-2" />
        <span className="text-gray-600">Verifying access...</span>
      </div>
    );
  }

  // If we reach here, user is authenticated, render the protected route
  return <>{children}</>;
};
